import { initSubRoutes } from '../../../../utils/router';

const RoutesAdressePrincipaleAdresse = initSubRoutes({
    route: '/adresse-principale/:idAdresse',
    subroutes: {},
    nom: 'Modification de votre adresse principale',
});

export default RoutesAdressePrincipaleAdresse;
